import React from 'react';
import { connect } from 'react-redux';

import {
  setContainerFullWidthOption,
  setContainerFixedOption
} from '../actions/container-actions';

export const ContainerOptions = ({ device, rows, options, onFullWidthChange, onFixedChange }) => {
  const { fullWidth, fixed } = options;

  return (
    <div className="header-builder-container-options">
      <div>
        <label>
          <input type="checkbox" checked={!!fullWidth} onChange={onFullWidthChange} />
          &nbsp;Full width
        </label>
      </div>
      <div>
        <label>
          <input type="checkbox" checked={!!fixed} onChange={onFixedChange} />
          &nbsp;Fixed
        </label>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { device } = ownProps;

  return {
    onFullWidthChange(e) {
      dispatch(setContainerFullWidthOption(device, e.target.checked));
    },

    onFixedChange(e) {
      dispatch(setContainerFixedOption(device, e.target.checked));
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(ContainerOptions);



// WEBPACK FOOTER //
// ./app/header-builder/components/ContainerOptions.js